import { Injectable } from '@angular/core';
import { UserAuthService } from './user-auth.sevice';

import { featureName, moduleName, operationName } from '../constant/user-role-constant';

@Injectable({
  providedIn: 'root'
})
export class ActionPermissionService {

  constructor(
    private userAuthService: UserAuthService
  ) { }

  isActionAllowed(permissionKey: string): boolean {
    const permissionSets = this.getPermissionSets(permissionKey);
    let hasPermission = this.userAuthService.hasPermission(permissionSets)
    return hasPermission;
  }

  private getPermissionSets(permissionKey: string): { moduleName: string, featureName: string, operationName: string }[] {
    let permissionSets: { moduleName: string, featureName: string, operationName: string }[] = [];

    switch (permissionKey) {
      case 'canEditTask':
        permissionSets = [
          { moduleName: moduleName.task, featureName: featureName.taskManagement, operationName: operationName.view },
          { moduleName: moduleName.task, featureName: featureName.taskManagement, operationName: operationName.write },
          { moduleName: moduleName.task, featureName: featureName.taskSpecialPermission, operationName: operationName.view }
        ];
        break;

      case 'canArchiveTask':
        permissionSets = [
          { moduleName: moduleName.task, featureName: featureName.taskManagement, operationName: operationName.delete },
          { moduleName: moduleName.task, featureName: featureName.taskSpecialPermission, operationName: operationName.delete }
        ];
        break;

      case 'canConvertReferral':
        permissionSets = [
          { moduleName: moduleName.referral, featureName: featureName.patientReferral, operationName: operationName.write }
        ];
        break;

      case 'canRemoveReferral':
        permissionSets = [
          { moduleName: moduleName.referral, featureName: featureName.patientReferral, operationName: operationName.delete },
        ];
        break;

      default:
        permissionSets = [];
    }

    return permissionSets;
  }

}